module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-left"
  }, [_vm._v("See dying vegetables life sustain,")]), _vm._v(" "), _c('p', {
    staticClass: "fm-left1"
  }, [_vm._v("See life dissolving vegetate again;")]), _vm._v(" "), _c('p', {
    staticClass: "fm-left1"
  }, [_vm._v("All forms that perish other forms supply.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-left1"
  }, [_vm._v("(By turns we catch the vital breath and die)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-left1"
  }, [_vm._v("Like bubbles on the sea of matter borne,")]), _vm._v(" "), _c('p', {
    staticClass: "fm-left1"
  }, [_vm._v("They rise, they break, and to that sea return.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-left2"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LEXANDER")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OPE")]), _vm._v(": "), _c('i', [_vm._v("Essay on Man")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495aa1af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 72
// module chunks = 0